<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-align-bottom`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 34a1 1 0 01-1-1V7a1 1 0 011-1h8a1 1 0 011 1v26a1 1 0 01-1 1h-8zm-7 4c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1h38c.55 0 1-.45 1-1v-2c0-.55-.45-1-1-1H5zm22-5a1 1 0 001 1h8a1 1 0 001-1V17a1 1 0 00-1-1h-8a1 1 0 00-1 1v16z"/></svg>
</template>
<script>

export default {
  name: 'IconAlignBottom',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
